
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.33333 4.49998C5.33333 3.7636 5.93029 3.16665 6.66667 3.16665C7.03486 3.16665 7.33333 2.86817 7.33333 2.49998C7.33333 2.13179 7.03486 1.83331 6.66667 1.83331C5.19391 1.83331 4 3.02722 4 4.49998C4 5.97274 5.19391 7.16665 6.66667 7.16665C7.03486 7.16665 7.33333 6.86817 7.33333 6.49998C7.33333 6.13179 7.03486 5.83331 6.66667 5.83331C5.93029 5.83331 5.33333 5.23636 5.33333 4.49998ZM8.66667 4.49998C8.66667 3.7636 9.26362 3.16665 10 3.16665C10.7364 3.16665 11.3333 3.7636 11.3333 4.49998C11.3333 5.23636 10.7364 5.83331 10 5.83331C9.26362 5.83331 8.66667 5.23636 8.66667 4.49998ZM10 1.83331C8.52724 1.83331 7.33333 3.02722 7.33333 4.49998C7.33333 5.97274 8.52724 7.16665 10 7.16665C11.4728 7.16665 12.6667 5.97274 12.6667 4.49998C12.6667 3.02722 11.4728 1.83331 10 1.83331ZM5.33333 10.5C5.33333 9.02722 6.52724 7.83331 8 7.83331H12C13.4728 7.83331 14.6667 9.02722 14.6667 10.5V13.8333C14.6667 14.5697 14.0697 15.1666 13.3333 15.1666H6.66667C5.93029 15.1666 5.33333 14.5697 5.33333 13.8333V10.5ZM8 9.16665C7.26362 9.16665 6.66667 9.7636 6.66667 10.5V13.8333H13.3333V10.5C13.3333 9.7636 12.7364 9.16665 12 9.16665H8ZM3.33333 10.5C3.33333 9.7636 3.93029 9.16665 4.66667 9.16665H5C5.36819 9.16665 5.66667 8.86817 5.66667 8.49998C5.66667 8.13179 5.36819 7.83331 5 7.83331H4.66667C3.19391 7.83331 2 9.02722 2 10.5V13.8333C2 14.2015 2.29848 14.5 2.66667 14.5C3.03486 14.5 3.33333 14.2015 3.33333 13.8333V10.5Z","fill":"currentColor"}})])
          )
        }
      }
    